import type {
  AssessmentQuestion,
  AssessmentSection,
  QuestionInTemplate,
  QuestionnaireTemplateSection,
} from '@app/src/types/resourceExplorer'
import { DEFAULT_ASSESSMENT_POINTS, SCORING_TYPES } from './constants'
import type { AssessmentFormattedQuestion } from './types'

export const transformQuestionnaireQuestion = (question: QuestionInTemplate): AssessmentQuestion => ({
  questionId: question.id,
  question: question,
})

export const transformQuestionnaireSection = (section: QuestionnaireTemplateSection): AssessmentSection => ({
  id: section.id,
  name: section.title,
  questions: section.questions?.map(transformQuestionnaireQuestion) || [],
  description: section.description,
  assessmentSectionNumber: section.order,
})

export const transformQuestionnaireSections = (
  sections: QuestionnaireTemplateSection[] | undefined,
): AssessmentSection[] => {
  return sections?.map(transformQuestionnaireSection) || []
}

export const formatQuestionForAssessment = (question: AssessmentQuestion): AssessmentFormattedQuestion | null => {
  return {
    questionId: question.questionId,
    points: question.points || {
      veryPositive: DEFAULT_ASSESSMENT_POINTS.VERY_POSITIVE,
      positive: DEFAULT_ASSESSMENT_POINTS.POSITIVE,
      neutral: DEFAULT_ASSESSMENT_POINTS.NEUTRAL,
      negative: DEFAULT_ASSESSMENT_POINTS.NEGATIVE,
      negativeAdverse: DEFAULT_ASSESSMENT_POINTS.NEGATIVE_ADVERSE,
      isCustom: false,
    },
    impactValueType: question.points?.isCustom ? SCORING_TYPES.CUSTOM : SCORING_TYPES.DEFAULT,
  }
}

export const formatSectionsForAssessment = (formSections: AssessmentSection[]) => {
  return formSections.map(section => ({
    id: section.id,
    name: section.name,
    description: section.description,
    assessmentSectionNumber: section.assessmentSectionNumber,
    questions: section.questions?.map(formatQuestionForAssessment) || [],
  }))
}
